/* edit-section */
$(function() {
    $('.editSection').each(function(i, editSection) {
        var editSectionTrigger = '.editSectionTrigger';
        var editSectionContent = '.editSectionContent';
        var findEditSectionTrigger = $(this).find(editSectionTrigger);
        var findEditSectionContent = $(this).find(editSectionContent);

        // Apply ARIA and display values on load
        if (findEditSectionTrigger.hasClass('__active')) {
            findEditSectionTrigger.attr('aria-expanded', true);
            findEditSectionContent.show();
            findEditSectionContent.attr('aria-hidden', false);
        } else {
            findEditSectionTrigger.attr('aria-expanded', false);
            findEditSectionContent.hide();
            findEditSectionContent.attr('aria-hidden', true);
        }

        // On click of edit-section trigger
        findEditSectionTrigger.click(function(e) {
            e.preventDefault();
            /* close an open edit-section */
            if ($(this).hasClass('__active')) {
                $(this).attr('aria-expanded', false);
                $(this).removeClass('__active');
                findEditSectionContent.slideUp();
                findEditSectionContent.attr('aria-hidden', true);
            } /* open a closed edit-section and close open siblings without the editSectionManualClose class*/ else {
                $(this).attr('aria-expanded', true);
                $(this).parents('.editSection').not('.editSectionManualClose').siblings().children('.editSectionTrigger').attr('aria-expanded', false);
                $(this).addClass('__active');
                $(this).parents('.editSection').not('.editSectionManualClose').siblings().children('.editSectionTrigger').removeClass('__active');
                findEditSectionContent.slideDown();
                $(this).parents('.editSection').not('.editSectionManualClose').siblings().children('.editSectionContent').slideUp();
                findEditSectionContent.attr('aria-hidden', false);
                $(this).parents('.editSection').not('.editSectionManualClose').siblings().children('.editSectionContent').attr('aria-hidden', true);
            }
        });
    });
});
